import { UtmClidSource } from './enums';
import type { ClidMatch } from './types';

const CLID_PARAMS: { names: string[]; source: UtmClidSource }[] = [
    { names: ['gclid'], source: UtmClidSource.Google },
    { names: ['gbraid'], source: UtmClidSource.Google },
    { names: ['wbraid'], source: UtmClidSource.Google },
    { names: ['fbclid'], source: UtmClidSource.Meta },
    { names: ['ttclid'], source: UtmClidSource.Tiktok },
    { names: ['sccid', 'ScCid'], source: UtmClidSource.Snapchat },
    { names: ['msclkid'], source: UtmClidSource.Bing },
    { names: ['li_fat_id'], source: UtmClidSource.Linkedin },
];

function getParamCaseInsensitive(search: URLSearchParams, names: string[]): string | null {
    for (const name of names) {
        const exact = search.get(name);
        if (exact) return exact;
    }
    const wanted = new Set(names.map((n) => n.toLowerCase()));
    let found: string | null = null;
    search.forEach((value, key) => {
        if (!found && wanted.has(key.toLowerCase()) && value) found = value;
    });
    return found;
}

export function findClid(search: URLSearchParams): ClidMatch | null {
    for (const row of CLID_PARAMS) {
        const value = getParamCaseInsensitive(search, row.names);
        if (value) return { clid: value, clidSource: row.source };
    }
    return null;
}

export function synthesiseFromClid(
    match: ClidMatch,
    referrerHostname: string | null,
): { source: string; medium: string; campaign: string; confidence: 'certain' | 'inferred' } {
    switch (match.clidSource) {
        case UtmClidSource.Google:
            return { source: 'google', medium: 'cpc', campaign: 'unmapped-google-ads', confidence: 'certain' };
        case UtmClidSource.Bing:
            return { source: 'bing', medium: 'cpc', campaign: 'unmapped-bing', confidence: 'inferred' };
        case UtmClidSource.Tiktok:
            return { source: 'tiktok', medium: 'paid-social', campaign: 'unmapped-tiktok', confidence: 'inferred' };
        case UtmClidSource.Snapchat:
            return { source: 'snapchat', medium: 'paid-social', campaign: 'unmapped-snapchat', confidence: 'inferred' };
        case UtmClidSource.Linkedin:
            return { source: 'linkedin', medium: 'paid-social', campaign: 'unmapped-linkedin', confidence: 'inferred' };
        case UtmClidSource.Meta: {
            const isInstagram = referrerHostname === 'instagram.com';
            return {
                source: isInstagram ? 'instagram' : 'facebook',
                medium: 'paid-social',
                campaign: 'unmapped-meta',
                confidence: 'inferred',
            };
        }
        default:
            return { source: match.clidSource, medium: 'cpc', campaign: `unmapped-${match.clidSource}`, confidence: 'inferred' };
    }
}
